function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "remove_svg__a"
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceGraphic",
  values: "0 0 0 0 0.168627 0 0 0 0 0.168627 0 0 0 0 0.168627 0 0 0 1.000000 0"
})));
var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#remove_svg__a)"
}, /*#__PURE__*/React.createElement("circle", {
  fill: "#2B2B2B",
  fillRule: "nonzero",
  cx: 20,
  cy: 20,
  r: 20
})), /*#__PURE__*/React.createElement("path", {
  d: "M30.17 11.785l-8.078 8.214 8.078 8.216-2.128 2.092L20 22.127l-8.042 8.18-2.128-2.092 8.078-8.216-8.078-8.214 2.128-2.092L20 17.872l8.042-8.179 2.128 2.092z",
  fill: "#FFF",
  fillRule: "nonzero"
}));
function SvgRemove(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}
export default SvgRemove;